import { createMockComponent } from '~/tests/helpers/createMockComponent';

const MetadataForm = createMockComponent('MetadataForm', 'metadata-form');

export default MetadataForm;
